module.exports = __webpack_public_path__ + "img/Menu.85e053e9.svg";